"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  author: "Mariana Silva",
  quote: "O olhar artístico e a atenção aos detalhes transformaram completamente a percepção da nossa marca.",
  position: "Diretora Criativa"
}, {
  author: "Ricardo Fontes",
  quote: "Um ambiente que respira inspiração. Cada projeto entregue supera nossas expectativas estéticas.",
  position: "Fundador, Galeria Luz"
}];
export default function WordFromTheField() {
  return <section data-section-id="229612" id="prova-social" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_minimalist_texture.png)] bg-cover bg-center blur-none scale-100 opacity-5"></div>
        <div className="absolute inset-0 bg-background/50 backdrop-blur-none"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-widest text-foreground">
            Vozes do <span className="text-primary">Estúdio</span>
          </h2>
          <div className="w-24 h-1.5 bg-primary mx-auto mt-8"></div>
        </div>

        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <Card className="bg-transparent border-none shadow-none">
                  <CardContent className="flex flex-col items-center text-center p-4 md:p-12">
                    <Quote className="size-12 md:size-16 text-primary mb-8 opacity-40" />
                    <p className="font-default text-2xl md:text-3xl lg:text-4xl italic font-normal leading-relaxed mb-12 text-foreground max-w-4xl mx-auto">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex flex-col items-center uppercase tracking-widest">
                      <span className="font-default font-bold text-lg md:text-xl text-primary mb-2">
                        {testimonial.author}
                      </span>
                      <span className="font-default text-xs md:text-sm text-muted-foreground font-medium">
                        {testimonial.position}
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <CarouselPrevious className="hidden md:flex rounded-full border border-border bg-background hover:bg-primary hover:text-primary-foreground hover:border-primary size-14 transition-all duration-200 ease-out" />
          <CarouselNext className="hidden md:flex rounded-full border border-border bg-background hover:bg-primary hover:text-primary-foreground hover:border-primary size-14 transition-all duration-200 ease-out" />
          
          {}
          <div className="flex items-center justify-center gap-4 mt-8 md:hidden">
            <CarouselPrevious className="relative inset-auto transform-none rounded-full border border-border bg-background hover:bg-primary hover:text-primary-foreground hover:border-primary size-12 transition-all duration-200 ease-out" />
            <CarouselNext className="relative inset-auto transform-none rounded-full border border-border bg-background hover:bg-primary hover:text-primary-foreground hover:border-primary size-12 transition-all duration-200 ease-out" />
          </div>
        </Carousel>
      </div>
    </section>;
}